import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MobileServiceService {
  
  private mobileBreakpoint = 768;

  constructor() { }

  checkMobile(): boolean {
    return window.innerWidth < this.mobileBreakpoint;
  }

  isMobile(): boolean {
    return this.checkMobile();
  }

  isTablet(): boolean {
    return window.innerWidth >= this.mobileBreakpoint && window.innerWidth < 1024;
  }

  isDesktop(): boolean {
    return window.innerWidth >= 1024;
  }

  getScreenWidth(): number {
    return window.innerWidth;
  }

  getScreenHeight(): number {
    return window.innerHeight;
  }
}